// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"style-module_cardTitle__2Prpc9ODHtPmdjH1CnOWkl"};